import default1Src from "./assets/default-1.webm";
import default2Src from "./assets/default-2.webm";
import default3Src from "./assets/default-3.webm";
import default4Src from "./assets/default-4.webm";
import default5Src from "./assets/default-5.webm";
import default6Src from "./assets/default-6.webm";
import default7Src from "./assets/default-7.webm";
import default8Src from "./assets/default-8.webm";
import default9Src from "./assets/default-9.webm";

interface DefaultCTAVisual {
  id: string;
  name: string;
  src: string;
}

const DEFAULT_CTA_VISUALS_DICT: Record<string, Omit<DefaultCTAVisual, "id">> = {
  "default-1": { name: "Questions & answers", src: default1Src },
  "default-2": { name: "Available 24/7", src: default2Src },
  "default-3": { name: "Light bulb idea", src: default3Src },
  "default-4": { name: "Send email", src: default4Src },
  "default-5": { name: "Business growth", src: default5Src },
  "default-6": { name: "Live chat", src: default6Src },
  "default-7": { name: "Incoming message", src: default7Src },
  "default-8": { name: "Hand wave", src: default8Src },
  "default-9": { name: "Get info", src: default9Src },
};

export const getDefaultCTAVisual = (id: string): DefaultCTAVisual => {
  const matchingVisual =
    DEFAULT_CTA_VISUALS_DICT[id as keyof typeof DEFAULT_CTA_VISUALS_DICT];

  if (!matchingVisual) {
    return {
      id: "default-1",
      ...DEFAULT_CTA_VISUALS_DICT["default-1"],
    };
  }

  return {
    id,
    ...matchingVisual,
  };
};

export const defaultCTAVisualList = Object.keys(
  DEFAULT_CTA_VISUALS_DICT
).reduce<DefaultCTAVisual[]>((acc, key) => {
  acc.push({
    id: key,
    ...DEFAULT_CTA_VISUALS_DICT[key as keyof typeof DEFAULT_CTA_VISUALS_DICT],
  });

  return acc;
}, []);
